module.exports = __webpack_public_path__ + "static/media/Voyager-RE-4700-iQ.9305e2f3.png";